<div class="wfl-dialog-container">

  <!-- Header -->
  <div class="wfl-dialog-header">
    <div class="wfl-header-left">
      <span class="wfl-header-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1363DF" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      </span>
      <h2 class="wfl-dialog-title">{{ workflowName }} Logs</h2>
    </div>
    <button class="wfl-close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="wfl-dialog-body">
    <div class="wfl-log-table-wrapper">
      <table class="wfl-log-table">
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Level</th>
            <th>Step</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of logs" class="wfl-row-{{ log.level.toLowerCase() }}">
            <td class="wfl-td-timestamp">{{ log.timestamp }}</td>
            <td class="wfl-td-level">
              <span class="wfl-level-badge wfl-level-{{ log.level.toLowerCase() }}">{{ log.level }}</span>
            </td>
            <td class="wfl-td-step">{{ log.step }}</td>
            <td class="wfl-td-message">{{ log.message }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Footer -->
  <div class="wfl-dialog-footer">
    <span class="wfl-log-count">{{ logs.length }} log entries</span>
    <button class="wfl-close-footer-btn" (click)="close()">Close</button>
  </div>

</div>
